<template>
  <el-form label-position="right" label-width="110px">
    <el-form-item v-for="column in columns" :key="column.prop" :label="column.label">
      <el-input v-model="team[column.prop]" readonly></el-input>
    </el-form-item>
    <el-form-item label="施工队介绍:">
      <el-input v-model="team.electronicFence" :rows="3" type="textarea" placeholder="施工队介绍" readonly />
    </el-form-item>
  </el-form>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      columns: [
        { label: '施工队名称:', prop: 'teamName' },
        { label: '所属单位名称:', prop: 'teamOrgName' },
        { label: '现场负责人:', prop: 'siteLeaderName' },
        { label: '负责人电话:', prop: 'siteLeaderPhone' }
      ]
    };
  },
  props: {
    team: Object
  }
});
</script>